export { default } from './InputCheckbox';
